import Intro from "../sections/Intro";
import Experience from "../sections/Experience";
import Domains from "../sections/Domains";
import SelectedProjects from "../sections/Projects"; 

function Home() {
  return (
    <>
      <Intro />
      <Experience />
      <Domains />
      <SelectedProjects />
    </>
  );
}

export default Home;
